module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/components/administration-dashboard.component.scss
// module id = ./src/app/administration/components/administration-dashboard.component.scss
// module chunks = main